import { render, staticRenderFns } from "./CampaignSubLink.vue?vue&type=template&id=244b579c&scoped=true"
import script from "./CampaignSubLink.vue?vue&type=script&lang=js"
export * from "./CampaignSubLink.vue?vue&type=script&lang=js"
import style0 from "./CampaignSubLink.vue?vue&type=style&index=0&id=244b579c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244b579c",
  null
  
)

export default component.exports